import request from '../util/request'; // 导入配置好的axios文件

export function getTopQuestion() {
  return request({
    url: 'colorOS/business/search/getTopQuestion',
    method: 'get'
  });
}

export function getSearchFetch(data) {
  return request({
    url: 'colorOS/business/search/searchInfo',
    method: 'get',
    params: data
  });
}

// 获取所有品牌信息
export function getMobileList(params) {
  return request({
    url: 'colorOS/business/rom/brandList',
    method: 'get',
    params: params
  });
}

// 获取产品名称数据
export function getMobileData(params) {
  return request({
    url: 'colorOS/business/rom/productList',
    method: 'get',
    params: params
  });
}

// 获取产品详细信息
export function getMobileId(params) {
  return request({
    url: 'colorOS/business/rom/romList',
    method: 'get',
    params: params
  });
}
